import { Component, inject, input, OnInit, signal } from '@angular/core';
import { AdminEmptyStateComponent, AdminModalComponent } from '../../../../shared/admin';
import type { FeatureRequestAttachment } from '../../../../shared/models/feature-request.models';
import { FeatureRequestsService } from '../../../../shared/services/feature-requests.service';

@Component({
  selector: 'app-feature-request-attachments-card',
  standalone: true,
  imports: [AdminEmptyStateComponent, AdminModalComponent],
  templateUrl: './feature-request-attachments-card.component.html',
  styleUrl: './feature-request-attachments-card.component.scss',
})
export class FeatureRequestAttachmentsCardComponent implements OnInit {
  private readonly service = inject(FeatureRequestsService);

  readonly requestId = input.required<string>();

  readonly attachments = signal<FeatureRequestAttachment[]>([]);
  readonly loading = signal(false);
  readonly previewUrl = signal<string | null>(null);
  readonly previewTitle = signal('');

  ngOnInit(): void {
    this.load();
  }

  reload(): void {
    this.load();
  }

  isImage(mime?: string): boolean {
    return Boolean(mime?.startsWith('image/'));
  }

  openPreview(item: FeatureRequestAttachment): void {
    if (!this.isImage(item.mimeType)) return;
    this.previewUrl.set(item.fileUrl);
    this.previewTitle.set(item.fileName);
  }

  closePreview(): void {
    this.previewUrl.set(null);
    this.previewTitle.set('');
  }

  private load(): void {
    this.loading.set(true);
    this.service.listAttachments(this.requestId()).subscribe({
      next: (items) => {
        this.attachments.set(items);
        this.loading.set(false);
      },
      error: () => this.loading.set(false),
    });
  }
}
